var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VRow',[_c('VCol',{staticClass:"mx-auto",attrs:{"cols":"12","md":"10"}},[_c('VCard',[_c('div',{staticClass:"px-8 py-8",domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }